package nacholab.supplies.storage

import kotlinx.browser.localStorage
import nacholab.supplies.domain.PreferencesRepository
import org.w3c.dom.get
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

class PreferencesRepositoryImpl: PreferencesRepository {

    companion object{
        const val DEVICE_ID = "device_id"
        const val SESSION_ID = "session_id"
    }

    override suspend fun getSessionId() = localStorage[SESSION_ID]?:""

    override suspend fun storeSessionId(sessionId: String) {
        localStorage.setItem(SESSION_ID, sessionId)
    }

    @OptIn(ExperimentalUuidApi::class)
    override suspend fun getDeviceId(): String {
        val storedDeviceId = localStorage[DEVICE_ID]
        return if (storedDeviceId.isNullOrBlank()){
            val newDeviceId = Uuid.random().toString()
            localStorage.setItem(DEVICE_ID, newDeviceId)
            newDeviceId
        }else storedDeviceId
    }
}